import React from 'react';

export function detectPlatform(input = '') {
  if (!input) return 'generic';
  let text = '';
  if (typeof input === 'object') {
    text = `${input.platform || ''} ${input.category || ''} ${input.name || ''}`;
  } else {
    text = String(input);
  }
  const t = text.toLowerCase();

  if (t.includes('whatsapp') || t.includes('wa ') || t.includes('wa/')) return 'whatsapp';
  if (t.includes('instagram') || t.includes('insta') || t.includes(' ig ') || t.startsWith('ig ')) return 'instagram';
  if (t.includes('tiktok') || t.includes('tik tok')) return 'tiktok';
  if (t.includes('youtube') || t.includes('yt ') || t.includes('shorts')) return 'youtube';
  if (t.includes('facebook') || t.includes('fb ') || t.includes('fb-') || t.includes('fb/')) return 'facebook';
  if (t.includes('telegram') || t.includes('tg ') || t.includes('tg/')) return 'telegram';
  if (t.includes('twitter') || t.includes(' x ') || t.startsWith('x ') || t.includes('tweet') || t.includes('x.com')) return 'twitter';
  if (t.includes('spotify')) return 'spotify';
  if (t.includes('snapchat') || t.includes('snap ')) return 'snapchat';
  if (t.includes('linkedin')) return 'linkedin';
  if (t.includes('discord')) return 'discord';
  if (t.includes('google')) return 'google';
  if (t.includes('website') || t.includes('traffic') || t.includes('seo')) return 'website';

  return 'generic';
}

export default function PlatformIcon({ platform = '', size = 44, iconSize = 22, style = {}, className = '' }) {
  const p = detectPlatform(platform);
  const radius = Math.round(size * 0.28);

  const baseStyle = {
    width: size,
    height: size,
    borderRadius: radius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    ...style,
  };

  if (p === 'instagram') {
    return (
      <div
        className={className}
        style={{
          ...baseStyle,
          background: 'linear-gradient(45deg, #F58529 0%, #FEDA77 15%, #DD2A7B 50%, #8134AF 80%, #515BD4 100%)',
          color: '#ffffff',
        }}
      >
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
        </svg>
      </div>
    );
  }

  if (p === 'tiktok') {
    return (
      <div
        className={className}
        style={{
          ...baseStyle,
          background: '#0F172A',
          color: '#FFFFFF',
          position: 'relative',
        }}
      >
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.29 0 .58.04.86.11V9.4a6.33 6.33 0 0 0-.86-.06 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.75a8.28 8.28 0 0 0 4.84 1.55V6.86a4.84 4.84 0 0 1-1.07-.17z" />
        </svg>
      </div>
    );
  }

  if (p === 'youtube') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#FF0000', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      </div>
    );
  }

  if (p === 'facebook') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#1877F2', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      </div>
    );
  }

  if (p === 'whatsapp') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#25D366', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.031 0C5.396 0 .029 5.367.029 11.987c0 2.108.549 4.168 1.595 5.97L.005 24l6.19-1.622a11.94 11.94 0 0 0 5.836 1.509h.005c6.632 0 12-5.367 12-11.987C24.036 5.368 18.665 0 12.031 0zm-.005 21.903a9.96 9.96 0 0 1-5.076-1.39l-.364-.216-3.771.989 1.006-3.676-.237-.377a9.914 9.914 0 0 1-1.52-5.246c0-5.502 4.48-9.982 9.987-9.982 2.666 0 5.172 1.038 7.058 2.925a9.928 9.928 0 0 1 2.921 7.062c-.005 5.503-4.485 9.986-9.994 9.986zm5.474-7.481c-.3-.15-1.776-.876-2.052-.976-.275-.101-.476-.15-.676.15s-.777.976-.952 1.176-.351.226-.652.075a8.215 8.215 0 0 1-2.417-1.493 9.07 9.07 0 0 1-1.674-2.083c-.176-.301-.019-.464.132-.614.135-.135.301-.351.451-.527.151-.176.201-.301.301-.502.101-.201.05-.376-.025-.526-.075-.151-.676-1.63-.927-2.232-.244-.587-.492-.507-.676-.516l-.577-.01c-.2 0-.526.075-.802.376-.275.301-1.052 1.028-1.052 2.508 0 1.48 1.077 2.91 1.228 3.111.15.201 2.119 3.235 5.134 4.538.718.31 1.278.496 1.716.635.72.229 1.376.197 1.895.119.578-.087 1.776-.726 2.027-1.428.25-.702.25-1.304.175-1.428-.075-.126-.275-.201-.576-.351z" />
        </svg>
      </div>
    );
  }

  if (p === 'telegram') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#229ED9', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
        </svg>
      </div>
    );
  }

  if (p === 'twitter') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#0F172A', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      </div>
    );
  }

  if (p === 'spotify') {
    return (
      <div className={className} style={{ ...baseStyle, background: '#1DB954', color: '#FFFFFF' }}>
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.508 17.308c-.217.356-.677.469-1.033.252-2.827-1.728-6.386-2.119-10.579-1.163-.408.093-.816-.161-.909-.569-.093-.408.161-.816.569-.909 4.593-1.049 8.528-.609 11.699 1.332.356.217.469.677.252 1.033zm1.47-3.261c-.273.444-.855.584-1.299.311-3.237-1.99-8.171-2.565-11.999-1.403-.5.152-1.033-.131-1.185-.631-.152-.5.131-1.033.631-1.185 4.382-1.33 9.816-.689 13.542 1.609.444.273.584.855.311 1.299zm.126-3.398C15.228 8.359 8.825 8.147 5.14 9.266c-.596.181-1.229-.158-1.41-.754-.181-.596.158-1.229.754-1.41 4.237-1.286 11.31-1.037 15.782 1.619.537.319.713 1.018.394 1.555-.319.537-1.018.713-1.555.394z" />
        </svg>
      </div>
    );
  }

  // Generic fallback
  return (
    <div className={className} style={{ ...baseStyle, background: 'linear-gradient(135deg, #0084FF 0%, #0052FF 100%)', color: '#FFFFFF' }}>
      <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
      </svg>
    </div>
  );
}
